import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import { post } from '../../../helpers/api_helper';
import * as types from './actionTypes';

function* fetchClaimsSaga(action) {
  const { unit_id, create_by } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);
    formData.append('create_by', create_by);
    const response = yield call(post, process.env.REACT_APP_FETCH_CLAIMS, formData);
    yield put({ type: types.FETCH_CLAIMS_SUCCESS, payload: response.data?.trip_list ?? [] });
  } catch (error) {
    yield put({ type: types.FETCH_CLAIMS_FAILURE, payload: error.message });
  }
}

function* saveClaimSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_CLAIM, action.payload);
    if (!response || response.status !== 'success') throw new Error(response?.message || 'Failed to save claim!');
    yield put({ type: types.SAVE_CLAIM_SUCCESS, payload: response });
    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire('Error', error.message || 'Something went wrong while saving!', 'error');
    yield put({ type: types.SAVE_CLAIM_FAILURE, payload: error });
  }
}

function* changeClaimStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CHANGE_CLAIM_STATUS, action.payload);
    if (!response || response.status !== 'success') throw new Error(response?.message || 'Failed to change claim status!');
    yield put({ type: types.CHANGE_CLAIM_STATUS_SUCCESS, payload: response });
    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire('Error', error.message || 'Something went wrong while changing status!', 'error');
    yield put({ type: types.CHANGE_CLAIM_STATUS_FAILURE, payload: error });
  }
}

function* fetchClaimApprovalsSaga(action) {
  const { unit_id, create_by } = action.payload;
  try {
    const formData = new FormData();
    formData.append('unit_id', unit_id);
    formData.append('create_by', create_by);
    const response = yield call(post, process.env.REACT_APP_FETCH_CLAIM_APPROVALS, formData);
    yield put({ type: types.FETCH_CLAIM_APPROVALS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_CLAIM_APPROVALS_FAILURE, payload: error.message });
  }
}

function* saveClaimApprovalSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_CLAIM_APPROVAL, action.payload);
    if (!response || response.status !== 'success') throw new Error(response?.message || 'Failed to save approval!');
    yield put({ type: types.SAVE_CLAIM_APPROVAL_SUCCESS, payload: response });
    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire('Error', error.message || 'Something went wrong while saving approval!', 'error');
    yield put({ type: types.SAVE_CLAIM_APPROVAL_FAILURE, payload: error });
  }
}

function* changeClaimApprovalStatusSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_CHANGE_CLAIM_APPROVAL_STATUS, action.payload);
    if (!response || response.status !== 'success') throw new Error(response?.message || 'Failed to change approval status!');
    yield put({ type: types.CHANGE_CLAIM_APPROVAL_STATUS_SUCCESS, payload: response });
    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire('Error', error.message || 'Something went wrong while changing approval status!', 'error');
    yield put({ type: types.CHANGE_CLAIM_APPROVAL_STATUS_FAILURE, payload: error });
  }
}

function* handleFetchViewClaimList(action) {
  const { unit_id, claim_id } = action.payload;
  try {
    const formData = new FormData();
    formData.append('claim_id', claim_id);
    formData.append('unit_id', unit_id);
    const response = yield call(post, process.env.REACT_APP_FETCH_VIEW_CLAIM_LIST, formData);
    yield put({ type: types.FETCH_VIEW_CLAIM_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: types.FETCH_VIEW_CLAIM_LIST_FAILURE, payload: error.message });
  }
}

function* sendClaimApprovalSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SEND_REIMBURSEMENT_CLAIM, action.payload);
    if (!response || response.status !== 'success') throw new Error(response?.message || 'Failed to send claim approval!');
    yield put({ type: types.SEND_CLAIM_APPROVAL_SUCCESS, payload: response });
    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire('Error', error.message || 'Something went wrong while sending claim approval!', 'error');
    yield put({ type: types.SEND_CLAIM_APPROVAL_FAILURE, payload: error });
  }
}

export default function* claimSagas() {
  yield takeLatest(types.FETCH_CLAIMS_REQUEST, fetchClaimsSaga);
  yield takeLatest(types.SAVE_CLAIM_REQUEST, saveClaimSaga);
  yield takeLatest(types.CHANGE_CLAIM_STATUS_REQUEST, changeClaimStatusSaga);

  yield takeLatest(types.FETCH_CLAIM_APPROVALS_REQUEST, fetchClaimApprovalsSaga);
  yield takeLatest(types.SAVE_CLAIM_APPROVAL_REQUEST, saveClaimApprovalSaga);
  yield takeLatest(types.CHANGE_CLAIM_APPROVAL_STATUS_REQUEST, changeClaimApprovalStatusSaga);

  yield takeLatest(types.FETCH_VIEW_CLAIM_LIST_REQUEST, handleFetchViewClaimList);
  yield takeLatest(types.SEND_CLAIM_APPROVAL_REQUEST, sendClaimApprovalSaga);
}
